import { combineReducers } from 'redux'
import { citiesReducer } from '../ducks/cities'
import { menuReducer } from '../ducks/menu'

export default combineReducers({
  city: citiesReducer,
  menu: menuReducer
})



// WEBPACK FOOTER //
// ./src/store/reducer.js